import { t as trapFocus, r as removeTrapFocus } from './index-BIftRuJC.js';

/**
 * @class FlyoutPanel
 * @extends {HTMLElement}
 */
class FlyoutPanel extends HTMLElement {
  /** @type {HTMLElement}  */
  button = this.querySelector('[data-flyout-panel="button"]');

  /** @type {HTMLElement} */
  offcanvas = this.querySelector('[data-flyout-panel="offcanvas"]');

  /** @type {HTMLElement} */
  selectedValue = this.querySelector('[data-flyout-panel="selected-value"]');

  /** @type {HTMLElement[]} */
  closes = this.querySelectorAll('[data-flyout-panel="close"]');

  connectedCallback() {
    this.button?.addEventListener('click', () => {
      this.open();
    });
    this.closes?.forEach((close) => {
      close?.addEventListener('click', () => {
        this.close();
      });
    });
  }

  open() {
    this.classList.add('is-open');
    this.button?.setAttribute('aria-expanded', 'true');
    trapFocus({ container: this.offcanvas });
  }

  close() {
    this.classList.remove('is-open');
    this.button?.setAttribute('aria-expanded', 'false');
    removeTrapFocus();
  }
}

customElements.define('flyout-panel', FlyoutPanel);
